// @flow strict

import { Button, Divider, Input, message, Modal, Tag } from 'antd';
import React, { useState } from 'react';
import { IoClose } from "react-icons/io5";
import { getCouponByCode } from '../../api/pricing';
import { INVALID_COUPON } from '../../constants/error';

function PlanPricing({ subscription, setCoupon, plan, coupon }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setCode("");
  };

  const handleClickApply = async () => {
    if (!code) {
      message.error("Please enter a valid coupon code!");
      return;
    };
    setLoading(true);

    try {
      const res = await getCouponByCode(code);
      if (res.data?.coupon) {
        setCoupon(res.data?.coupon);
        message.success(res?.data?.message);
        handleCloseModal();
      } else {
        message.error(INVALID_COUPON);
      }
    } catch (error) {
      message.error(INVALID_COUPON);
    } finally {
      setLoading(false);
    };
  };

  const handleClickRemove = () => {
    setCoupon(null);
  };

  const getPrice = () => {
    if (coupon) {
      return (plan?.price_amount * (100 - coupon.percent_off) / 100).toFixed(2);
    } else {
      return plan?.price_amount;
    }
  };

  return (
    <>
      {
        plan?.price_amount === 0 ?
          <>
            <p className="fs-5 font-text-bold text-primary">
              Free Forever
            </p>
            <p className="mt-0 text-success font-text-bold">
              No credit card required
            </p>
          </>
          :
          <>
            <div className="d-flex justify-content-between align-items-center">
              {
                coupon ?
                  <div className="">
                    <p className="d-flex gap-1 align-items-center font-text-bold">
                      <del className="text-secondary">{`$${plan.price_amount}`}</del>
                      <span>{`$${getPrice()}`}{`/${plan?.interval}`}</span>
                    </p>
                  </div>
                  :
                  <p className="font-text-bold text-primary">
                    <span className="fs-5">{`$${plan.price_amount}/`}</span>
                    <span>{`${plan?.interval}`}</span>
                  </p>
              }
              {
                !subscription?.subscriptionId &&
                (
                  coupon ?
                    <p className="text-success font-text-bold d-flex gap-1 align-items-center">
                      <Tag
                        onClick={handleClickRemove}
                        className="d-flex gap-1 align-items-center" color="cyan"
                      >
                        <IoClose />
                        <span>{coupon?.code}</span>
                      </Tag>
                      <span>Applied!</span>
                    </p>
                    :
                    <Button onClick={() => setIsModalOpen(true)} type="default">
                      Apply Coupon
                    </Button>
                )
              }
            </div>
            <p className="mt-0">Billed monthly</p>
            {
              coupon &&
              <p className="text-success font-text-bold">
                <>
                  {coupon?.duration === "once"
                    &&
                    <span>
                      You have got {coupon?.percent_off} % off for a month.
                    </span>
                  }
                </>
                <>
                  {coupon?.duration === "repeating"
                    &&
                    <span>
                      You have got {coupon?.percent_off} % off for {coupon?.duration_in_months} month.
                    </span>
                  }
                </>
                <>
                  {coupon?.duration === "forever"
                    &&
                    <span>
                      You have got {coupon?.percent_off} % off forever.
                    </span>
                  }
                </>
              </p>
            }
          </>
      }

      <Modal
        title="Apply Coupon Code"
        open={isModalOpen}
        onOk={handleClickApply}
        onCancel={handleCloseModal}
        okText="Apply"
        okButtonProps={{
          loading: loading
        }}
      >
        <Divider />
        <div className="mb-4">
          <Input
            placeholder="Write a valid coupon code!"
            onChange={(e) => setCode(e.target.value)}
            value={code}
          />
        </div>
      </Modal>
    </>
  );
};

export default PlanPricing;